"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateLoaderSize = void 0;
// Checks if loaderSize is a number and is less than 0
var validateLoaderSize = exports.validateLoaderSize = function validateLoaderSize(loaderSize) {
  return loaderSize < 0 ? 88 : Number(loaderSize);
};